<template>
    <el-card shadow="never">
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>banner图设置</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button type="primary" class="editbtn" @click="add()">创建</el-button>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="title" label="标题"/>
          <el-table-column label="图片" width="130">
            <template #default="scope">
              <img :src="scope.row.img" style="width: 100px;height: 100px;border-radius: 10px;" />
            </template>
          </el-table-column>
          <el-table-column prop="start_time" label="开始时间"/>
          <el-table-column prop="end_time" label="结束时间"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
                <el-switch
                size="large"
                @change="changeStatus(scope.row.id,scope.row.status)"
                v-model="scope.row.status"
                inline-prompt
                active-text="正常"
                inactive-text="暂停"
                />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row)" type="primary">编辑</el-button>
              <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
    </el-card>
    <el-dialog v-model="baseData.addbox" :title="baseData.title">
        <el-form :model="form" label-width="120">
          <el-form-item label="名称">
            <el-input v-model="form.title" autocomplete="off" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="封面图">
            <el-row class="martop">
              <el-upload
                class="avatar-uploader"
                action=""
                :http-request="uploadImg"
                :show-file-list="false"
              >
                <img v-if="form.img" :src="form.img" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-row>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
                v-model="form.start_time"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
                v-model="form.end_time"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">暂停</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="baseData.addbox = false">取消</el-button>
            <el-button type="primary" @click="save()">
              提交
            </el-button>
          </span>
        </template>
    </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    addbox:false,
  })
  const form = reactive({
    id:0,
    title:'',
    img:'',
    start_time:'',
    end_time:'',
    status:1,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const save = () => {
    baseData.loading = true
    if(form.id){
      api.bannersApi.edit(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.bannersApi.add(form).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.addbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const getList = () => {
    baseData.loading = true
    api.bannersApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    if(status){
      status = 1
    }else{
      status = 0
    }
    api.bannersApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.bannersApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    baseData.addbox = true
    baseData.title = '添加banner图'
    form.id = 0
    form.title = ""
    form.img = ""
    form.start_time = ""
    form.end_time = ""
    form.status = 1
  }
  const edit = (data:any) => {
    baseData.addbox = true
    baseData.title = '编辑banner图'
    form.id = data.id
    form.title = data.title
    form.img = data.img
    form.start_time = data.start_time
    form.end_time = data.end_time
    form.status = data.status == true ? 1 : 0
  }
  onMounted(() => {
    getList()
  })
  </script>